import React, { Component, Fragment } from "react";
import BacktestService from "../../../service/backtest.service";
import ContainerDimensions from "react-container-dimensions";
import NewPie from "../../d3Components/NewPieChart/pie";
import DataTable from "../../PortfolioDashboard/navigationPages/Datatable/DataTable";
import Spinner from "../../PortfolioDashboard/navigationPages/Datatable/spinner/spinner";
import WithCard from "../../common/withCard";

class AtRetirement extends Component {
  state = {
    getBacktest: [],
    tableData: [],
    newPieData: [],
    columns: [
      { title: "Symbol" },
      { title: "Name" },
      { title: "Asset Class" },
      { title: "Weight(%)" }
    ],
    pieChartData: [],
    spinner: false
  };

  async componentDidMount() {
    const { id } = this.props;
    const benchmark = "MSCI_AGG_20_80";
    const type = "LIVE";

    if (id !== 999) {
      this.setState({
        spinner: true
      });
      await BacktestService.getBacktest(
        `${id}`,
        `${benchmark}`,
        `${type}`
      ).then(res => {
        if (res) {
          this.setState({
            getBacktest: res,
            spinner: false
          });
        }
      });
      this.calculation();
    } else if (id === 999) {
      let pieData = [
        {
          label: "Typical Capital Protection Fund",
          value: 100
        }
      ];
      let tableData = [
        ["-", "TYPICAL CAPITAL PROTECTION FUND", "-", "100.0", "Treasuries"]
      ];
      this.setState({
        pieChartData: pieData,
        tableData: tableData,
        spinner: false
      });
    }
  }

  async componentWillReceiveProps(newProps) {
    const { id } = newProps;
    const benchmark = "MSCI_AGG_20_80";
    const type = "LIVE";
    if (newProps.id !== 999 && this.props.id !== newProps.id) {
      this.setState({
        spinner: true
      });
      await BacktestService.getBacktest(
        `${id}`,
        `${benchmark}`,
        `${type}`
      ).then(res => {
        if (res) {
          this.setState({
            getBacktest: res,
            spinner: false
          });
        }
      });
      this.calculation();
    } else if (newProps.id === 999) {
      let pieData = [
        {
          label: "Typical Capital Protection Fund",
          value: 100
        }
      ];
      let tableData = [
        ["-", "TYPICAL CAPITAL PROTECTION FUND", "-", "100.0", "Treasuries"]
      ];
      this.setState({
        pieChartData: pieData,
        tableData: tableData,
        spinner: false
      });
    }
  }

  calculation = () => {
    if (this.state.getBacktest) {
      let getPortfolioData = this.state.getBacktest.getPortfolioData;
      let portfolioFilter = [];
      let portfolioData = {};
      let PieData = [];

      for (let i in getPortfolioData) {
        let line = getPortfolioData[i];
        if (
          i == 0 ||
          (portfolioFilter[portfolioFilter.length - 1] &&
            portfolioFilter[portfolioFilter.length - 1].value != line.dt)
        ) {
          portfolioFilter.push({
            value: line.dt
          });
        }

        line.dt in portfolioData
          ? portfolioData[line.dt].push([
              line.symbol,
              line.fund_name,
              line.fund_asset_class_focus,
              line.allocation,
              line.style
            ])
          : (portfolioData[line.dt] = [
              [
                line.symbol,
                line.fund_name,
                line.fund_asset_class_focus,
                line.allocation,
                line.style
              ]
            ]);

        line.dt in PieData
          ? PieData[line.dt].push({
              fund: line.fund_asset_class_focus,
              allocation: line.allocation * 1,
              style: line.style
            })
          : (PieData[line.dt] = [
              {
                fund: line.fund_asset_class_focus,
                allocation: line.allocation * 1,
                style: line.style
              }
            ]);
      }
      let tableData = [];
      let newPieData = [];

      if (portfolioFilter.length > 0) {
        tableData =
          portfolioData[portfolioFilter[portfolioFilter.length - 1].value];
      }
      if (portfolioFilter.length > 0) {
        newPieData = PieData[portfolioFilter[portfolioFilter.length - 1].value];
      }

      //  pie data sum
      var obj = {};
      for (var i in newPieData) {
        if (!obj[newPieData[i]["fund"]]) {
          obj[newPieData[i]["fund"]] = newPieData[i]["allocation"];
        } else {
          obj[newPieData[i]["fund"]] =
            parseFloat(newPieData[i]["allocation"]) +
            obj[newPieData[i]["fund"]];
        }
      }
      let arr = [];
      for (let i in obj) {
        arr.push({ label: i, value: obj[i] });
      }
      this.setState({
        tableData,
        newPieData,
        pieChartData: arr
      });
    }
  };
  render() {
    const { selectedFundName, id } = this.props;
    const { columns, tableData, pieChartData } = this.state;

    return (
      <WithCard>
        <div className="row">
          {this.state.spinner == true ? (
            <div style={{ marginTop: "20px" }}>
              <Spinner />
            </div>
          ) : null}

          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            {this.state.spinner == false && pieChartData ? (
              <div style={{ textAlign: "center" }}>
                <ContainerDimensions>
                  {({ width }) => (
                    <Fragment>
                      {width > 0 ? (
                        <NewPie
                          width={width}
                          height={350}
                          id={"acc_pie2"}
                          color1={"#3c4694"}
                          color2={"#E8E9F6"}
                          data={pieChartData}
                        />
                      ) : null}
                    </Fragment>
                  )}
                </ContainerDimensions>
                <div style={{ fontWeight: "bold" }}>
                  {id !== 999 ? selectedFundName : null}
                </div>
              </div>
            ) : null}
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            {this.state.spinner == false && tableData.length ? (
              <DataTable
                data={tableData}
                columns={columns}
                paging={true}
                searching={false}
              />
            ) : null}
          </div>
        </div>
      </WithCard>
    );
  }
}

export default AtRetirement;



// WEBPACK FOOTER //
// ./src/components/pages/Retire/atRetirement.jsx